import { render } from "./LeitnerSingleBox.vue?vue&type=template&id=22a3d22a&scoped=true&ts=true"
import script from "./LeitnerSingleBox.vue?vue&type=script&lang=ts"
export * from "./LeitnerSingleBox.vue?vue&type=script&lang=ts"

import "./LeitnerSingleBox.vue?vue&type=style&index=0&id=22a3d22a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a3d22a"]])

export default __exports__